import React from 'react';
import './Footer.css';

export default class Footer extends React.Component {
	render() {
		return (
			<div className="footer text-center d-print-none"><span className="copyrightText">{this.props.text} &#169; {new Date().getFullYear()}</span></div>
		);
	}
}